import { defineComponent as _defineComponent } from 'vue'
import {computed, PropType} from 'vue';
import PackingContents from '@/components/order/PackingContentsV2.vue';
import {Bundle} from '@/types/Bundle';
import { MappedOrderLines} from "@/types/WavePicking";
import { SmartOrderMapped } from '@/types/ApiSmartOrders';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToteContents',
  props: {
  order: {
    type: Object as PropType<SmartOrderMapped>,
    required: true,
  }
},
  setup(__props) {

const props = __props;



const nonBundleItems = computed((): MappedOrderLines[] => props.order.items.filter(item => !item.in_bundle))
const bundles = computed((): Bundle[] => props.order.bundles)

return { __sfc: true,props, nonBundleItems, bundles, PackingContents }
}

})